import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/flag': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M336.2 80c35.5 0 73-12.7 108.9-28.2 31.6-13.7 66.9 9.7 66.9 44.1v239.9c0 16.2-8.2 31.3-21.7 40.2-26.6 17.4-70.1 40-128.5 40-68.6 0-112.8-32-161.9-32-56.6 0-90 11.3-127.8 28.6v83.4c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-406.4c-14.3-8.3-24-23.8-24-41.6 0-27.6 23.2-49.7 51.2-47.9 23 1.5 41.9 19.5 44.5 42.3 0.2 1.5 0.3 4 0.3 5.5 0 4.3-1.1 11.1-2.5 15.2 22.4-8.7 49.4-15.2 80.7-15.2 68.6 0 112.8 32 161.9 32zM464 336v-240c-31.5 14.6-84.6 32-127.8 32-59.9 0-102-32-161.9-32-41.4 0-80.5 16.6-102.3 32v232c31.4-14.6 84.5-24 127.8-24 59.9 0 102 32 161.9 32 41.4 0 80.5-16.6 102.3-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/flag.js
// module id = 1741
// module chunks = 0